import React from 'react';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import Title from "./Title";
import {Typography} from "@mui/material";

function NothingFound(props) {
    return (
        <div
            className={props.classes.nothingFoundComponent}

        >
            {
                !!props.image &&
                    <img src={props.image} alt={props.title}/>
            }
            {
                !!props.icon &&
                <div className="icon-holder">
                    {props.icon}
                </div>

            }
            <Title color={props.title_color}>{props.title}</Title>
            <Typography>{props.paragraph}</Typography>
            {props.children}
        </div>
    );
}
export default withStyles(Styles)(NothingFound);